export const decodeBase64 = (encodeStr:any) => {
  const urlDecodedString = decodeURIComponent(encodeStr);

  const decodedString = atob(urlDecodedString);

  return decodedString;
}